import React, { Fragment } from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './ComparisonTableBlock.scss';

// @ts-ignore
import Reveal from 'react-reveal/Reveal';
import { sendEvent } from '../../../utils';
import CONFIG from '../../../config';

import Filter from '../../Elements/Filter/Filter';
import Title from '../../Elements/Title/Title';
import ComparisonTable from '../../Elements/ComparisonTable/ComparisonTable';
import Image from '../../Elements/Image/Image';

interface IComparisonTableBlockProps {
  context?: IContent;
}

const ComparisonTableBlock = ({ context }: IComparisonTableBlockProps) => {
  const { comparison_table } = context;

  return (
    <Fragment>
      <Title titles={context.comparison_table.colorful_title} color="#FFD900" />
      <Reveal
        onReveal={() => sendEvent('compare editions - tab displayed - scroll')}
      >
        <div className="block-comparison-table">
          <div className={`container${CONFIG.isUPC ? ' upc' : ''}`}>
            <div
              className="content"
              style={CONFIG.isUPC ? { width: '100%' } : {}}
            >
              <ComparisonTable />
              <div>
                <div className="horizontal-line-mobile no-display-desktop">
                  <Image
                    imageName="horizontal_line_mobile.png"
                    altText={comparison_table.standard.title}
                  />
                </div>
                {!CONFIG.isUPC && (
                  <Filter
                    title={comparison_table.select.title}
                    defaultSelected={
                      comparison_table.filter &&
                      comparison_table.filter.default_selected
                    }
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </Fragment>
  );
};

export default withContent(ComparisonTableBlock);
